import {useAccessPayConfiguration, useMutationWithErrorHandling, usePost} from '@app/sdk';

export function useClearReports() {
  const post = usePost();
  const { data: accessPayConfig } = useAccessPayConfiguration();

  async function clearReports() {
    const request = {};
    return await post(`${accessPayConfig?.baseUrl}/debug/reports/reset`, request);
  }

  return useMutationWithErrorHandling({
    mutationFn: clearReports,
  });
}
